import { protocolClassNames } from '../classes'
export const delayedResultsUISchema = {
  delayed_results_certification: {
    "ui:options": {
      title: "Delayed Results Certification",
      classNames: protocolClassNames
    },
    result_type: {
      "ui:options": {
        title: "Delayed Results Type",
        label: false,
        required: true,
        classNames: {
          fieldContainer: "rjs-full",
          field: "rjs-col-md"
        }
      }
    },
    intervention_name: {
      "ui:options": {
        label: false,
        title: "Intervention Name (s)",
        classNames: {
          fieldContainer: "rjs-col-lg",
        }
      }
    },
    application_number: {
      "ui:options": {
        label: false,
        title: "FDA Application Number(s)",
        classNames: {
          fieldContainer: "rjs-col-lg",
        }
      }
    },
    month: {
      "ui:options": {
        title: "Month",
        label: false,
        classNames: {
          fieldContainer: "rjs-col-sm",
        }
      }
    },
    day: {
      "ui:options": {
        title: "Day",
        label: false,
        classNames: {
          fieldContainer: "rjs-col-sm",
        }
      }
    },
    year: {
      "ui:options": {
        title: "Year",
        label: false,
        classNames: {
          fieldContainer: "rjs-col-sm",
        }
      }
    },
    explaination: {
      "ui:options": {
        label: false,
        title: "Explanation",
        charCountEnabled: true,
        maxChars: 999,
        classNames: {
          fieldContainer: "rjs-full",
        }
      },
      "ui:widget": "TextareaWidget"
    },
    appeal_delayed_results_decision: {
      "ui:options": {
        label: false,
        title: "Appeal Delayed Results Decision: Enter Justification",
        tooltip: "This field does not update PRS, if you have a good cause extension that is rejected, you will need to manually add this explanation to PRS",
        charCountEnabled: true,
        maxChars: 999,
        classNames: {
          fieldContainer: "rjs-full",
        }
      },
      "ui:widget": "TextareaWidget"
    }
  },
}